const YandexMetrikaInformer = () => {
    return (
        <div className="yandex-metrika-informer">
            {/* Yandex.Metrika informer */}
            <a 
                href="https://metrika.yandex.ru/stat/?id=103617854&amp;from=informer" 
                target="_blank" 
                rel="nofollow"
            >
                <img 
                    src="https://informer.yandex.ru/informer/103617854/3_1_FFFFFFFF_EFEFEFFF_0_pageviews"
                    style={{width: '88px', height: '31px', border: 0}}
                    alt="Яндекс.Метрика"
                    title="Яндекс.Метрика: данные за сегодня (просмотры, визиты и уникальные посетители)"
                    className="ym-advanced-informer" 
                    data-cid="103617854" 
                    data-lang="ru"
                />
            </a>
            {/* /Yandex.Metrika informer */}
        </div>
    );
};

export default YandexMetrikaInformer;

